import * as React from 'react';
import { SVGProps } from 'react';

const IconBookSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 2a1 1 0 0 1 1-1v5l1.25-.952L5.5 6V1H9a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H3.5a.5.5 0 0 0 0 1H10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V2Z" />
  </svg>
);
export default IconBookSizeXs;
